/**
 * Gitee / Git blob 的 content 是 base64。先按字节解码，再用 UTF-8 严格模式转字符串；
 * 这样内容仓如果不是 UTF-8，会在这里报错，而不是把替换字符写进 IndexedDB。
 */
export function decodeBase64Utf8(value: string): string {
  const clean = value.replace(/\s+/g, '')
  if (clean.length === 0) return ''

  const binary = atob(clean)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)

  return new TextDecoder('utf-8', { fatal: true }).decode(bytes)
}
